import { createAction } from "@reduxjs/toolkit";

enum NotificationActionTypes {
    NOTIFICATIONS_SHOW = "[Notifications] SHOW",
    NOTIFICATIONS_RESET = "[Notifications] RESET",
}

export const showNotificationActionCreator = createAction<string>(NotificationActionTypes.NOTIFICATIONS_SHOW);
export const resetNotificationActionCreator = createAction(NotificationActionTypes.NOTIFICATIONS_RESET);
